<template>
  <div>
    <b-card>
      <p>ALS is always looking for innovative approaches to working with our customers. Please get in touch using the following methods:</p>
      <ul class="list-unstyled">
        <li>
          <font-awesome-icon icon="phone" fixed-width class="mr-2"/>+64 7 974 4740
        </li>
        <li>
          <font-awesome-icon icon="envelope" fixed-width class="mr-2"/>
          <a href="mailto:ALSFood.Hamilton@alsglobal.com">ALSFood.Hamilton@alsglobal.com</a>
        </li>
        <li class="mb-3">
          <font-awesome-icon icon="external-link-alt" fixed-width class="mr-2"/>
          <a href="https://www.analytica.co.nz" target="_blank">www.analytica.co.nz</a>
        </li>
        <li>
          <strong>Ruakura Research Centre</strong>
          <br>10 Bisley Road,
          <br>Private Bag 3123,
          <br>Hamilton 3214
          <br>New Zealand
        </li>
      </ul>
    </b-card>
  </div>
</template>

<script>
import PortalSidebar from "@/components/PortalSidebar.vue";
import PortalPageHeader from "@/components/PortalPageHeader.vue";

export default {
  name: "Contact",
  components: {
    PortalSidebar,
    PortalPageHeader
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {}
};
</script>
<style lang="scss">
@import "../assets/styles/main.scss";
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue